import { authClient } from "@/lib/auth-client"
import type { AuthUser } from "@/server/lib/auth"

export function useSession() {
  const {
    data,
    isPending,
    error,
    refetch
  } = authClient.useSession()
  return {
    session: data?.session,
    user: data?.user as AuthUser | undefined,
    isPending,
    error,
    refetch
  }
}
